import { useMutation } from '@tanstack/react-query'

import { deleteMeasure, DeleteMeasureProps } from './services/deleteMeasure'
import { invalidateLoadMeasuresByFormAndClientId } from './useLoadMeasuresByFormAndClientId'
type Props = {
  formId: string
  clientId: string
}
export const useDeleteMeasure = ({ formId, clientId }: Props) => {
  const mutation = useMutation({
    mutationFn: async (data: DeleteMeasureProps) => await deleteMeasure(data),
    onSuccess: async () =>
      await invalidateLoadMeasuresByFormAndClientId(formId, clientId),
  })

  const deleteMeasureReq = async (data: DeleteMeasureProps) => {
    return mutation.mutateAsync(data)
  }

  return {
    deleteMeasure: deleteMeasureReq,
    ...mutation,
  }
}
